import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { rusPassportCode } from '../../../../constants/constants';
import { employeeTids } from '../../../../constants/tids';
import { FieldWrapper } from '../../../FieldWrapper';
import { TrimmedInput } from '../../../TrimmedInput';
export const DocumentNumberField = ({ value, documentType, onValueChange, validationInfo, disabled, labelClassName, }) => {
    useEffect(() => {
        if (documentType === rusPassportCode) {
            const documentNumber = value
                .replace(/\D/g, '')
                .substring(0, 10)
                .replace(/^(\d{4})(\d{0,6})$/, '$1 $2');
            onValueChange(documentNumber);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentType]);
    return (_jsx(FieldWrapper, { label: "\u0421\u0435\u0440\u0438\u044F \u0438 \u043D\u043E\u043C\u0435\u0440", labelClassName: labelClassName, children: _jsx(TrimmedInput, { width: 120, value: value, onValueChange: onValueChange, validationInfo: validationInfo, "data-tid": employeeTids.documentNumberInput, mask: documentType === rusPassportCode ? '9999 999999' : undefined, disabled: disabled }) }));
};
